export default __webpack_public_path__ + "images/Sagittal_View_of_the_Brain.daac109611c33d81ca823cdab0a983a3.png";